/**
 * Debug Context
 *
 * Provides global debug mode state that can be toggled on/off
 */

import { createContext, useContext, useState } from "react";

const DebugContext = createContext({
  isDebugMode: false,
  toggleDebug: () => {},
  depthLevel: 0,
  setDepthLevel: () => {},
  maxDepth: 20,
  setMaxDepth: () => {},
});

export const useDebug = () => {
  const context = useContext(DebugContext);
  if (!context) {
    throw new Error("useDebug must be used within a DebugProvider");
  }
  return context;
};

export default DebugContext;
